import Axios from 'axios';
import _ from 'lodash';
import appActions from '@app/redux/app/actions';
import authActions from '@app/redux/auth/actions';

const interceptor = (store) => {
    Axios.interceptors.response.use(
        (next) => {
            return Promise.resolve(next);
        }, (error) => {
            if (error.response){
                let {response} = error;

                if (error.response && error.response.status === 401) {
                    store.dispatch(appActions.setErrors([{msg: 'Tu sesión expiró o no es válida. Inicia sesión nuevamente'}]));
                    store.dispatch(authActions.logout());
                }

                if (error.response && error.response.status === 403) {
                    store.dispatch(appActions.setErrors([{msg: 'No tienes permisos para esta acción'}]));
                }

                if (!response.data || response.data.ok == false) {
                    store.dispatch(appActions.setErrors([{msg: response.data.payload}]));
                }

                if (_.isArray(response.data)) {
                    store.dispatch(appActions.setErrors(response.data));
                }
            }else if(error.request){
            }else if(error.message){
            }
            return Promise.reject(error);
        },
    );
};
export default interceptor;
